/*
2020/01/21 (二)
ContentEditor 新增Entity指南
1. 在(vue)web_admin/src/utils/content-editor/entities.js 新增
2. 在(vue)web_admin/src/utils/content-editor/components/blocks 新增
3. 在(vue)web_admin/src/utils/content-editor/components/ContentEditorBlock 套用步驟2新增的
4. 在(golang)website/utils/content-editor/model/content.go 新增相關
5. 在(html)website_frontend/src/html 文章相關html 新增相關
6. 在(html)website_frontend/src/utils/content-editor/content-editor.css 新增相關
*/
function Title (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'title'
  this.value = ''// string
}

function Subtitle (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'subtitle'
  this.value = ''// string
}

function Content (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'content'
  this.value = ''// html
}

function Quote (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'quote'
  this.value = ''// html, same with content
}

function Comment (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'comment'
  this.value = ''// html, same with content
}

function Link (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'link'
  this.value = {
    title: '',
    url: '', // url
    isOpenInNewTab: false
  }
}

function Image (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'image'
  this.value = {
    title: '',
    alt: '',
    img: null, // blob or url
    thumb: null,
    url: ''
  }
}

// youtube
function Video (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'video'
  this.value = {
    id: '',
    width: 560,
    height: 315,
    ratio: 56.25
  }
}

// 網址影片
function VideoFromURL (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'videofromurl'
  this.value = ''// url
}

function Carousel (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'carousel'
  this.value = {
    settings: {}, // reserved
    items: [] // {type: video, value: ''} or {type: image, value: {參考Image}}
  }
}

function Code (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'code'
  this.value = ''// html, same with content
}

// 可以自由輸入 html, css, javascript
function HTMLCode (id) {
  this.id = id
  this.type = 'htmlcode'
  this.value = ''// html, same with Code
}

function Complex (id) {
  this.id = id // 僅僅是為了v-for需要有:key的用題
  this.type = 'complex'
  this.value = {
    value1: new Content(),
    value2: new Content()
  }
}

const all = [
  /* type 就是型別，通常是物件類別的小寫 */
  /* Class 就是物件類別 */
  /* title 用在用在新增圓形按鈕 */
  /* name 用在? */
  /* hint 用在? */
  /* icon 用在新增圓形按鈕 或 改變型別下拉選單 */
  {
    type: 'title',
    Class: Title,
    title: '標',
    name: '標題',
    hint: '新增標題',
    icon: null
  },
  {
    type: 'subtitle',
    Class: Subtitle,
    title: '次',
    name: '次標題',
    hint: '新增次標題',
    icon: null
  },
  {
    type: 'content',
    Class: Content,
    title: '文',
    name: '內文',
    hint: '新增內文',
    icon: null
  },
  {
    type: 'quote',
    Class: Quote,
    title: '引',
    name: '引言',
    hint: '新增引言',
    icon: null
  },
  {
    type: 'comment',
    Class: Comment,
    title: null,
    name: '註解',
    hint: '新增註解',
    icon: 'el-icon-s-comment'
  },
  {
    type: 'link',
    Class: Link,
    title: null,
    name: '連結',
    hint: '新增連結',
    icon: 'el-icon-link'
  },
  {
    type: 'image',
    Class: Image,
    title: null,
    name: '圖片',
    hint: '新增圖片',
    icon: 'el-icon-picture-outline'
  },
  {
    type: 'video',
    Class: Video,
    title: null,
    name: '影片',
    hint: '新增影片',
    icon: 'el-icon-video-camera'
  },
  // {
  //   type: 'videofromurl',
  //   Class: VideoFromURL,
  //   title: null,
  //   name: '影片網址',
  //   hint: '影片網址',
  //   icon: 'el-icon-video-camera'
  // },
  {
    type: 'carousel',
    Class: Carousel,
    title: null,
    name: '幻燈片',
    hint: '新增幻燈片',
    icon: 'el-icon-s-platform'
  },
  {
    type: 'code',
    Class: Code,
    title: null,
    name: '編輯器',
    hint: '新增編輯器',
    icon: 'el-icon-edit'
  },
  // {
  //   type: 'htmlcode',
  //   Class: HTMLCode,
  //   title: null,
  //   name: '程式碼',
  //   hint: '新增程式碼',
  //   icon: 'el-icon-edit'
  // },
  {
    type: 'complex',
    Class: Complex,
    title: null,
    name: '複合',
    hint: '新增複合區塊',
    icon: 'el-icon-menu'
  }
]

const Entity = {
  Title,
  Subtitle,
  Content,
  Quote,
  Comment,
  Link,
  Image,
  Video,
  VideoFromURL,
  Carousel,
  Code,
  HTMLCode,
  Complex,
  all,
  types: all.map(o => o.type)
}

for (var i = 0; i < all.length; ++i) {
  let entityInfo = all[i]
  Entity[entityInfo.type + 'Idx'] = all.findIndex(o => o.type === entityInfo.type)
}

export default Entity
